export default "__VITE_ASSET__D$iQjXTt__"